<iframe *ngIf="iframeAuthToken" class="probo-profile" [src]="sanitizedUrl"></iframe>

<div *ngIf="!iframeAuthToken">
  <div class="portfolio__container">
    <div class="portfolio__message">
      <h1>Yet not connected</h1>
      <p>
        Once connected, you'll be able to see your information here. Stay tuned!
      </p>
    </div>
  </div>

</div>
